import { useSearchParams } from "react-router-dom";

export function useQueryParam(name: string): string | null {
    const [searchParams] = useSearchParams();
    return searchParams.get(name);
}
